import { EolaMember } from 'enums/teamMemberData'
import { Translate } from 'next-translate'

const translateEolaMember = (person: EolaMember, t: Translate) => {
  const hyphenateString = (string: string) => {
    return string.replace(/ /g, '-').toLowerCase()
  }
  return {
    role: t(`about:${hyphenateString(person.role)}`),
    favouriteActivity: t(
      `activityType:${hyphenateString(person.favouriteActivityType)}`
    )
  }
}

export default translateEolaMember
